import { Components, Theme } from '@mui/material/styles';

import * as Colors from 'src/theme/colors';

const MuiAutocomplete: Components<Theme>['MuiAutocomplete'] = {
  styleOverrides: {
    inputRoot: {
      '&.MuiOutlinedInput-root': {
        padding: '0px 4.5px',
      },
    },
    option: {
      '&.Mui-focused': {
        backgroundColor: Colors.HoverNonBorderBackground,
      },
    },
  },
};

export default MuiAutocomplete;
